module.exports = __webpack_public_path__ + "static/media/undraw_secure_login_pdn4.7ca2c126.svg";